import {
	POST,
	GET,
	Delete,
} from "../util";

const inspectionUrl = "api/seller/put-option/inspection";
const operationUrl = "api/seller/put-option/operation";
const url = {
	inspection: {
		debtors: `${inspectionUrl}/debtors`,
		counts: `${inspectionUrl}/counts`,
		listRequests: `${inspectionUrl}/list-requests`,
		listActive: `${inspectionUrl}/list-active`,
		listContracts: `${inspectionUrl}/list-contracts`,
		listReceivables: `${inspectionUrl}/list-receivables/:optionId`,
		details: `${inspectionUrl}/:id/details`,
		config: `${inspectionUrl}/config`,
		paymentPlan: `${inspectionUrl}/:optionId/payment-plan`,
	},
	operation: {
		save: `${operationUrl}/save`,
		publish: `${operationUrl}/save-and-publish`,
		delete: `${operationUrl}/:id/delete`,
		withdraw: `${operationUrl}/:id/withdraw`,
		accept: `${operationUrl}/:offerId/accept-offer`,
		cancel: `${operationUrl}/:optionId/cancel?ordinary=:ordinary`
	},
};

const revolvingPutOptionsSellerApi = {
	inspection: {
		getDebtors: () => {
			return GET(url.inspection.debtors);
		},
		getCounts: () => {
			return GET(url.inspection.counts);
		},
		listRequests: (params = {}) => {
			return POST(url.inspection.listRequests, params);
		},
		listActive: (params = {}) => {
			return POST(url.inspection.listActive, params);
		},
		listContracts: (params = {}) => {
			return POST(url.inspection.listContracts, params);
		},
		getDetails: (id) => {
			return GET(url.inspection.details.replace(":id", id));
		},
		getConfig: () => {
			return GET(url.inspection.config);
		},
		getPaymentPlan: (optionId) => {
			return GET(url.inspection.paymentPlan.replace(":optionId", optionId));
		},
		listReceivables: (optionId, params = {}) => {
			return POST(url.inspection.listReceivables.replace(":optionId", optionId), params);
		},
	},

	operation: {
		savePutOption: (params = {}) => {
			return POST(url.operation.save, params);
		},
		publishPutOption: (params = {}) => {
			return POST(url.operation.publish, params);
		},
		deletePutOption: (id, params = {}) => {
			return Delete(url.operation.delete.replace(":id", id), params);
		},
		withdrawPutOption: (id, params = {}) => {
			return POST(url.operation.withdraw.replace(":id", id), params);
		},
		acceptOffer: (offerId, params = {}) => {
			return POST(url.operation.accept.replace(":offerId", offerId), params, "application/json", 'String');
		},
		cancelPutOption: (optionId, ordinary) => {
			return POST(url.operation.cancel.replace(":optionId", optionId).replace(":ordinary", ordinary));
		}
	}

};
export {
	revolvingPutOptionsSellerApi
};